import React from 'react'
import store from 'store'
import $ from 'jquery';
import Page from '../Page'
import { QueryParam, API_CATEGORY, FormatPrice , BASE_URL } from '../Util'
import { Row, Col, Preloader, Icon } from 'react-materialize'
import { Link } from 'react-router-dom'
import { trans } from "../Lang";
import "../../styles/app.css";

class Catalogue extends Page {
	static LIMIT = 20;

	constructor(props) {
      super(props);
      let params = QueryParam();

      this.state = {
         categories: null,
         loadingCategory: true
      };
      this.categoryClick = this.categoryClick.bind(this);
	}

	componentDidMount() {
      this.handleLoadData();
      let element = document.querySelector('.loading');
      if (element) {
         element.style.display = 'none'; // Contoh: Menyembunyikan elemen
       }

	}

  handleLoadData = (params) => {
  		if (!params) {
  			params = this.state.params;
  		}

  		$.getJSON(API_CATEGORY)
        .then((data) => {
          this.setState({ categories: data.payload, loadingCategory: false });
      });
	}

	categoryClick = (category, subcategory, e) =>{
	}

   render() {
      let categories = this.state.categories;

      if (categories === null) {
         return super.render();
      }
      return(
         <Row className="container">
            <Col s={12}>
               <h4 className="mb-m mt-l">Katalog {trans.course}</h4>
               <hr />
            </Col>

            {this.state.loadingCategory && (
               <center className="pt-m loading">
                  <Preloader size="big" />
               </center>
            )}
            {this.state.loadingCategory ||
               this.state.categories.map((category, i) => (
                  <Col
                     s={12}
                     m={category.subcategories.length > 6 ? 9 : 6}
                     className="height-100 pr-s"
                     key={i}
                  >
                     <div className="valign-wrapper mb-xs">
                        <img
                           className="tiny mr-s"
                           src={category.icon_url}
                        />
                        <div className="h5">{category.name}</div>
                     </div>
                     <div style={{ marginLeft: "45px" }}>
                        {Array.isArray(category.subcategories) &&
                           category.subcategories.map((subcategory, j) => (
                              <span className="inline" key={j}>
                                 <Link
                                    className="modal-close"
                                    to={`/course/catalog?category_id=${subcategory.id}`}
                                 >
                                    {subcategory.name} (
                                    {subcategory.available_courses.length})
                                 </Link>{" "}
                                 &nbsp; &nbsp;{" "}
                              </span>
                           ))}
                     </div>
                  </Col>
               ))}
         </Row>
      )
   }
}

export default Catalogue




// WEBPACK FOOTER //
// ./src/components/Public/Catalogue.js